import React from "react";
import { useHistory } from "react-router-dom";
import { AiOutlineUser } from "react-icons/ai";
import styles from "./senderMessage.module.css";
import axios from "axios";
const SenderMessage = ({ conv, user }) => {
  console.log("single conv", conv);
  const history = useHistory();

  const getOneConversation = () => {
    axios
      .post("https://arianaapp.arianaapply.com/api/V1/chat/get-messages", {
        admissioner_id: user._id,
        client_id: conv.client[0]._id,
      })
      .then((res) => {
        console.log(res);
        history
          .push({
            pathname: `/messenger/chat/${res.data[0].conversation_id}`,
            state: {
              receiver: conv.client[0],
              conversation_id: res.data[0].conversation_id,
              myUser: user,
              members: res.data[1].members,
            },
          })
      }).catch((err) => {
        console.log(err);
      });
  };
  return (
    <div
      className={styles.senderMessage}
      onClick={() => getOneConversation()}
    >
      <div className={styles.senderImage}>
        <AiOutlineUser size={32} color="#059669" />
      </div>
      <div className={styles.senderDetails}>
        <h3>{conv.client[0].name}</h3>
        <p>
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده
          از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و
          سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای
          متنوع با هدف بهبود ابزارهای کاربردی می
        </p>
      </div>
      <div className={styles.sendingTime}>
        <span>14:30</span>
      </div>
    </div>
  );
};

export default SenderMessage;
